import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { UserData } from '../model/user-data';
import { UsersDataResponse } from '../model/users-data-response';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss'],
    standalone: false
})
export class ReportsComponent implements OnInit {
  reportForm: UntypedFormGroup;
  userData:UserData;
  user:UsersDataResponse;
  constructor(private fb: UntypedFormBuilder, private router: Router,private userservice:UserService,) {
    this.createForm();
    this.router.navigate(["/dcn-esign/reports/signed-orders-report"]);
  }

 
 
  ngOnInit(): void {
    this.userservice.getCurrentUser().subscribe(data=>{
      this.user=data;
      this.userData=data.userData;
  
     
    })
  }

  createForm() {

    this.reportForm = this.fb.group({


      selectedReport: new UntypedFormControl("1"),


    });
  }

  onReportSelect() {
   
  
    let selectedReport = this.reportForm.controls.selectedReport.value;
    switch (parseInt(selectedReport)) {
      case 1:
        this.router.navigate(["/dcn-esign/reports/signed-orders-report"]);
        break;
      case 2:
        this.router.navigate(["/dcn-esign/reports/unsigned-packages-report"])
        break;
      case 3:
        this.router.navigate(["/dcn-esign/reports/mar-report"])
        break;
      case 4:
        this.router.navigate(["/dcn-esign/reports/missing-signature-report"])
        break;
      case 5:
        this.router.navigate(["/dcn-esign/reports/exception-report"])
        break;
      case 6:
        this.router.navigate(["/dcn-esign/reports/esa-report"])
        break;
      default:
        break;
    }
  }
}
